<template>
    <div class="gdetail">
        <div class="header">
            <div class="top">
                <img class="img" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230822/1692671454/429874.png" alt="">
                <div class="title">
                    <div>{{detail.name}}</div>
                    <div>
                        <div>
                            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230823/1692776405/123250.png" alt="">
                            <span>团队数量</span>
                        </div>
                        <div>
                            <span>{{sublist.length}}</span> 队
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div>
                    <div>
                        <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230824/1692846042/846469.png" alt="">
                        <span>盟主：</span>
                    </div>
                    <div>
                        <span>{{detail.connenter_name}}</span> ｜
                        <span>{{detail.connenter_phone}}</span>
                    </div>
                </div>
                <div class="btn" @click="call">一键拨出</div>
            </div>
        </div>
        <div class="hr"></div>
        <div class="body">
            <div class="title">联盟团队情况</div>
            <div class="list">
                <div class="item" v-for="item in sublist" :key="item.id">
                    <div>{{item.name}}</div>
                    <div>
                        <div>召集人：{{item.connenter_name}}</div>
                        <div>联系电话：{{item.connenter_phone}}</div>
                    </div>
                    <div>
                        <div>人数：{{item.num}} 人</div>
                        <div>每周频次：{{item.weeks}} / 次</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            detail: {},
            sublist: []
        }
    },
    mounted() {
        this.getdetail()
    },
    methods: {
        getdetail() {
            this.$api.system.groupdetail({aid:this.$route.params.aid}).then(res=>{
                this.detail = res.data
                this.sublist = res.data.allianceTeam
            })
        },
        call() {
            if(this.detail.connenter_phone)
                window.location.href = 'tel:'+this.detail.connenter_phone;
        }
    }
}
</script>

<style lang="less" scoped>
.gdetail{
    .header{
        .top{
            width: 100%;
            background-size: 100% 100%;
            display: flex;
            box-sizing: border-box;
            padding: .37rem .45rem .32rem;
            align-items: center;
            .img{
                width: .94rem;
                height: .94rem;
                border-radius: 50%;
            }
            .title{
                width: 4.8rem;
                margin-left: .3rem;
                >div:first-child{
                    font-size: .32rem;
                    color: rgba(0,0,0,0.85);
                    font-weight: 500;
                    padding-bottom: .1rem;
                }
                >div:nth-child(2){
                    font-size: .24rem;
                    color: #95999F;
                    display: flex;
                    align-items: center;
                    >div:first-child{
                        display: flex;
                        align-items: center;                     
                        img{
                            width: .3rem;
                            height: .3rem;
                            margin-right: .1rem;
                        }
                    }
                    >div:nth-child(2){
                        padding-left: .3rem;
                        span {
                            color: #025DF4;
                        }
                    }
                }
            }
        }
        .bottom{
            display: flex;
            align-items: center;
            box-sizing: border-box;
            padding: 0 .45rem .2rem;
            justify-content: space-between;
            width: 100%;
            >div:first-child{
                display: flex;
                width: 50%;
                font-size: .24rem;
                align-items: center;
                // justify-content: space-between;
                color: rgba(0,0,0,0.45);
                img{
                    width: .57rem;
                    height: .57rem;
                    margin-right: .1rem;
                }
                >div:first-child{
                    display: flex;
                    align-items: center;
                }
                >div:nth-child(2){
                    padding-left: .4rem;
                }
            }
            .btn{
                width: 1.4rem;
                height: .5rem;
                line-height: .5rem;
                text-align: center;
                background: #ffffff;
                border: .01rem solid #025DF4;
                border-radius: .25rem;
                font-size: .24rem;
                color: #025DF4;
            }
        }
        
    }
    .body{
        .title{
            color: #333;
            font-size: .3rem;
            border-bottom: .01rem solid rgba(238,238,238,1);
            padding: .3rem;
        }
        .list{
            .item{
                box-sizing: border-box;
                padding: .2rem;
                margin-bottom: .2rem;
                >div:first-child{
                   font-size: .36rem;
                    color: #000000; 
                }
                >div:nth-child(2),>div:nth-child(3){
                    font-size: .24rem;
                    color: rgba(0, 0, 0, .45);
                    display: flex;
                    align-items: center;
                    >div:nth-child(2){
                        padding-left: .2rem;
                    }
                }
            }
        }
    }
}
</style>